<div class="coverage-page">
    <div class="container h-100">
        <div class="info-content hide-mobile">
            <div class="info">
                <div class="portalLogo" (click)="gotoPage('coverage')" style="cursor: pointer;" title="Home"></div>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            </div>
            <contacts></contacts>
        </div>
        <div class="main-content flex-row justify-content-between flex-wrap align-items-center">
            <div class="box" (click)="gotoPage('verification-tractors')">
                <img src="../../../assets/car-icon.svg" alt="car-icon">
                <p>{{ _translateService.Keys.COVERAGE_UNIT_ID_CARDS | translate }}</p>
            </div>
            <div class="box" (click)="gotoPage('coverage-proposal')">
                <img src="../../../assets/policy-icon.svg" alt="policy-icon">
                {{ _translateService.Keys.COVERAGE_INSURANCE_SUMMARY | translate }}
            </div>
            <div class="box" [routerLink]="['/verification']">
                <img src="../../../assets/account-icon.svg" alt="account-icon">
                {{ _translateService.Keys.COVERAGE_AFP_ACCOUNT_INFO | translate }}
            </div>
            <div class="box" (click)="gotoPage('documents')">
                <img src="../../../assets/document-icon.svg" alt="document-icon">
                {{ _translateService.Keys.COVERAGE_MISC_DOCUMENTS | translate }}
            </div>
            <div class="box" (click)="gotoPage('analytics')">
                <img src="../../../assets/chart-mixed-icon.svg" alt="document-icon">
                {{ _translateService.Keys.COVERAGE_INCIDENTS_REPORTED | translate }}
            </div>
        </div>
    </div>
</div>
